import { axios } from '@carvana/purchase-utils';

export const getVehicleIdFromStockNumber = stockNumber =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/vehicle/getvehicleid/${stockNumber}`
  }).then(res => res.data);

export const getStockNumberFromVehicleId = vehicleId =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/vehicle/getstocknumber/${vehicleId}`
  }).then(res => res.data);

export const getCompareVehiclesByVehicleId = (
  currentVehicleId,
  newVehicleIdb
) =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/vehicle/compare/${currentVehicleId}/${newVehicleIdb}`
  }).then(res => res.data);

export const getSearchResult = <TResponse>(payload: any) =>
  axios
    .post<TResponse>(`${process.env.SEARCH_API_URL}/api/v2/search`, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.data);

export const fetchVerifications = () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/verification`
  }).then(res => res.data);
